<script lang="ts" setup>
import BsLinkArrowButton from '@/legacy/components/LinkArrowButton.vue'
import { InfoSectionTheme } from '@/types/InfoSectionLegacy'

defineProps({
	theme: {
		type: String,
		default: InfoSectionTheme.Info,
	},
	icon: {
		type: String,
		default: '',
	},
	content: {
		type: String,
		default: '',
	},
	arrowText: {
		type: String,
		default: '了解更多',
	},
	isNoLink: {
		type: Boolean,
		default: false,
	},
	action: {
		type: Function,
	},
})
</script>

<template>
	<div class="bs-info-section" :class="theme">
		<div class="bs-info-section--icon">
			<template v-if="icon === ''">
				<i class="bs-icon--info"></i>
			</template>
			<template v-else>
				<i :class="`bs-icon--${icon}`"></i>
			</template>
		</div>
		<div class="bs-info-section--content">
			<div class="bs-info-section--content__text">{{ content }}</div>
			<BsLinkArrowButton
				v-if="!isNoLink"
				:text="arrowText"
				:action="action"
				:theme="theme"
			/>
		</div>
	</div>
</template>
